import React from "react";
import { FaSearch, FaTimes, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

const chipClass = (active) =>
  `max-lg:min-h-11 max-lg:inline-flex max-lg:items-center px-3 py-1.5 text-sm rounded-lg font-display font-bold transition-colors ${
    active
      ? "bg-brand-charcoal text-brand-cream"
      : "bg-white text-brand-charcoal border border-brand-charcoal/20 hover:border-brand-charcoal"
  }`;

const sortChipClass = (active) =>
  `inline-flex items-center gap-1 max-lg:min-h-11 px-3 py-1.5 text-sm rounded-lg font-display font-bold transition-colors ${
    active
      ? "bg-brand-charcoal text-brand-cream"
      : "bg-white text-brand-charcoal border border-brand-charcoal/20 hover:border-brand-charcoal"
  }`;

const SortIcon = ({ field, sortBy, sortOrder }) => {
  if (sortBy !== field) {
    return <FaSort className="h-3 w-3 opacity-50" />;
  }
  return sortOrder === "asc" ? (
    <FaSortUp className="h-3 w-3" />
  ) : (
    <FaSortDown className="h-3 w-3" />
  );
};

const SORT_FIELDS = [
  { id: "firstName", label: "First name" },
  { id: "lastName", label: "Last name" },
  { id: "average", label: "Average" },
];

const AveragesToolbar = ({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  counts,
  sortBy,
  sortOrder,
  onSortChange,
  showNeedsAttention,
}) => {
  const filters = [
    { id: "all", label: `All (${counts.all})` },
    { id: "unverified", label: `Not verified (${counts.unverified})` },
    ...(showNeedsAttention
      ? [
          {
            id: "needs-attention",
            label: `Needs attention (${counts.needsAttention})`,
          },
        ]
      : []),
    { id: "verified", label: `Verified (${counts.verified})` },
    { id: "no-average", label: `No average (${counts.noAverage})` },
  ];

  return (
    <div className="px-4 sm:px-6 py-4 border-b border-brand-charcoal/10 space-y-3">
      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        <div className="relative flex-1">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="h-4 w-4 text-brand-mist" />
          </div>
          <input
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search any part of the name"
            className="block w-full pl-10 pr-9 py-2 border border-brand-charcoal/20 rounded-lg bg-white placeholder-brand-mist text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink sm:text-sm"
          />
          {search ? (
            <button
              type="button"
              onClick={() => onSearchChange("")}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-brand-mist hover:text-brand-charcoal"
              title="Clear search"
            >
              <FaTimes className="h-4 w-4" />
            </button>
          ) : null}
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {filters.map((filter) => (
          <button
            key={filter.id}
            type="button"
            onClick={() => onStatusFilterChange(filter.id)}
            className={chipClass(statusFilter === filter.id)}
          >
            {filter.label}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap items-center gap-2 md:hidden">
        <span className="text-xs font-display font-bold uppercase tracking-wider text-brand-muted">
          Sort
        </span>
        {SORT_FIELDS.map((field) => (
          <button
            key={field.id}
            type="button"
            onClick={() => onSortChange(field.id)}
            className={sortChipClass(sortBy === field.id)}
          >
            {field.label}
            <SortIcon
              field={field.id}
              sortBy={sortBy}
              sortOrder={sortOrder}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default AveragesToolbar;
